"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserDetailsCustomData = void 0;
const user_details_1 = require("@app/reducer/user-details");
const store_1 = require("@app/store");
const user_details_custom_data_1 = require("../../request/user-details-custom-data");
const employee_card_context_1 = require("../employee-card-context");
const useEmployeeCardData_1 = require("./useEmployeeCardData");
const useUserDetailsCustomData = () => {
    const { workspace, userId } = (0, employee_card_context_1.useEmployeeCard)();
    const dispatch = (0, store_1.useRootDispatch)();
    const { data, mutate } = (0, useEmployeeCardData_1.useEmployeeCardData)({
        actionName: 'user-details-custom-data',
        reducer: (data) => dispatch((0, user_details_1.setUserCustomData)(data?.customData)),
        selector: (state) => state.userDetails.customData,
        requestor: async () => await (0, user_details_custom_data_1.requestUserDetailsCustomData)({
            workspaceId: workspace?.id ?? '',
            userId: userId ?? '',
        }),
        mutator: async (inputData) => await (0, user_details_custom_data_1.mutateUserDetailsCustomData)({
            workspaceId: workspace?.id ?? '',
            userId: userId ?? '',
            data: { customData: inputData },
        }),
        listenDeps: [workspace?.id, userId],
    });
    return [data, mutate];
};
exports.useUserDetailsCustomData = useUserDetailsCustomData;
